import { render, staticRenderFns } from "./PayrollDocuments.vue?vue&type=template&id=79afd196"
import script from "./PayrollDocuments.vue?vue&type=script&lang=js"
export * from "./PayrollDocuments.vue?vue&type=script&lang=js"
import style0 from "./PayrollDocuments.vue?vue&type=style&index=0&id=79afd196&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports